export const newVersionPaths = [
  "/user/profile-new",
  "/basejw/appcenter",
  "/basejw/workshop",
  "/basejw/group",
  "/basejy/group/app",
  "/gaokao-subject-choice-app-new",
  "/smart-division-app",
  "/gaokao-smart-scheduling-app",
  "/gaokao-course-management-app-new",
  "/timetable-app",
  "/score-card-app-new",
  "/school-info-new",
  "/calendar-app",
  "/intl-school-info-app",
  "/intl-calendar-app",
  "/intl-subject-choice-app",
  "/intl-smart-division-legacy-app",
  "/intl-smart-division-app",
  "/intl-smart-scheduling-app",
  "/intl-course-management-app",
  "/intl-invigilation-app",
  "/intl-score-card-app",
  "/intl-admission-app",
];

export const getCurrentVersionPath = (pathname: string) => {
  if (typeof window === "undefined") {
    return pathname;
  }

  return (window.location.hash || "").replace(/^#/, "").split(/[?#]/)[0] || pathname;
};

export const isNewVersionPath = (pathname: string) =>
  newVersionPaths.some((path) => pathname === path || pathname.startsWith(`${path}/`));

export const navigateToHashPath = (path: string) => {
  const hashPath = path.startsWith("#") ? path : `#${path.startsWith("/") ? path : `/${path}`}`;
  const baseUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
  window.location.href = `${baseUrl}${hashPath}`;
};
